module.exports = __webpack_public_path__ + "market/static/img/grid_start.e18b8f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/grid_start.png
// module id = 00Zu
// module chunks = 1